import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Button,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  Paper,
  Snackbar,
  TextField,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog
} from '@material-ui/core';
import {
  Edit,
  Image
} from '@material-ui/icons';
import PerfectScrollbar from 'react-perfect-scrollbar';

const SERVER_ADDRESS = process.env.REACT_APP_SERVER_ADDRESS;

class Accueil extends React.Component {
  constructor() {
    super();
    this.state = {
      accueil: [],
      titre: "",
      liens: "",
      text: "",
      isLogged: true,
      redirect: false,
      newModalOpen: false,
      deleteModalOpen: false,
      deleteId: "",
      modifedId: "",
      snackbarMessage: "",
      snackbarOpen: false,
      sidebarOpen: false,
      putModalOpen: false,
      redirectLogOut: false,
      limit: false,
      selectFileImages: null,
      loaded1: false
    }
  }

  handleChangeInput = (event) => {
    switch (event.target.name) {
      case 'titre':
        this.setState({ titre: event.target.value })
        break;
      case 'liens':
        this.setState({ liens: event.target.value })
        break;
      case 'text':
        this.setState({ text: event.target.value })
        break;
      default:
        break;
    }
  }

  deleteBureau = () => {
    this.handleCloseDeleteModal();
    const actualite_id = this.state.accueil[this.state.deleteId].id
    fetch(SERVER_ADDRESS + '/accueil/' + actualite_id,
      {
        method: 'DELETE',
        headers: new Headers({
          'authorization': 'Bearer ' + localStorage.getItem('token')
        })
      }
    )
      .then(() => { this.getData() })
      .then(
        (res) => {
          this.setState({
            snackbarOpen: true,
            snackbarMessage: "Accueil supprimée"
          })
          setTimeout(() => {
            this.setState({ snackbarOpen: false })
          }, 3000);
        }
      )
  }

  addBureau = () => {
    this.handleCloseNewModal();
    this.onClickHandler();
    let accueil = {
      titre: this.state.titre,
      liens: this.state.liens,
      text: this.state.text
    }
    fetch(SERVER_ADDRESS + '/accueil',
      {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + localStorage.getItem('token')
        }),
        body: JSON.stringify(accueil),
      })
      .then(res => {
        res.json()
        console.log(res)
      })
      .then(() => { this.getData() })
      .then(res => this.setState({ snackbarMessage: "Accueil ajouté." }))
      .then(
        (res) => {
          this.setState({ snackbarOpen: true })
          setTimeout(() => {
            this.setState({ snackbarOpen: false })
          }, 3000);
        }
      )
  }

  putBureau = () => {
    this.handleClosePutModal();
    this.onClickHandler();
    let accueil = {
      titre: this.state.titre,
      liens: this.state.liens,
      text: this.state.text
    }
    let actualite_id = this.state.accueil[this.state.modifedId].id
    fetch(SERVER_ADDRESS + '/accueil/' + actualite_id,
      {
        method: 'PUT',
        headers: new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + localStorage.getItem('token')
        }),
        body: JSON.stringify(accueil),
      })
      .then(
        () => {
          fetch(SERVER_ADDRESS + '/accueil',
            {
              headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + localStorage.getItem('token')
              }),

            }
          )
            .then(res => res.json())
            .then(res => this.setState({ accueil: res }))
            .then(
              () => console.log(this.state.accueil)
            )
        }
      )
      .then(res => this.setState({ snackbarMessage: "Accueil modifiée." }))
      .then(
        (res) => {
          this.setState({ snackbarOpen: true })
          setTimeout(() => {
            this.setState({ snackbarOpen: false })
          }, 3000);
        }
      )
      .then(
        () => {
          const newArrayBureau = this.state.accueil
          newArrayBureau[this.state.modifedId] = {
            id: actualite_id,
            email: this.state.email
          }
          this.setState({ accueil: newArrayBureau })
        }
      )
  }

  handleClosePutModal = () => {
    this.setState({ putModalOpen: false })
  }

  handleOpenPutModal = (index) => {
    let user_id = this.state.accueil[index].id
    fetch(SERVER_ADDRESS + '/accueil/' + user_id)
      .then(res => res.json())
      .then(res => {
        this.setState({
          titre: res[0].titre,
          liens: res[0].liens,
          text: res[0].text
        }, () => {
          this.setState({ putModalOpen: true })
          this.setState({ modifedId: index })
        })
      })
  }

  handleCloseDeleteModal = () => {
    this.setState({ deleteModalOpen: false })
  }

  handleOpenDeleteModal = (index) => {
    this.setState({ deleteModalOpen: true })
    this.setState({ deleteId: index })
  }

  handleOpenNewModal = () => {
    this.setState({
      titre: "",
      liens: "",
      text: ""
    }, () => {
      this.setState({ newModalOpen: true })
    })
  }

  handleCloseNewModal = () => {
    this.setState({ newModalOpen: false })
  }

  openMenu = () => {
    this.setState({ sidebarOpen: !this.state.sidebarOpen })
    const menu = document.querySelector('.side-nav')
    if (this.state.sidebarOpen === false) {
      menu.style.display = "block"
    }
    else {
      menu.style.display = "none"
    }
  }

  getData = () => {
    fetch(SERVER_ADDRESS + '/accueil',
      {
        headers: new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + localStorage.getItem('token')
        }),

      }
    )
      .then(res => res.json())
      .then((res) => {
        this.setState({ accueil: res })
      })

  }

  componentDidMount() {
    const token = {
      token: localStorage.getItem('token')
    }

    fetch(SERVER_ADDRESS + '/token',
      {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json'
        }),
        body: JSON.stringify(token),
      })
      .then(res => res.json())
      .then(
        (res) => {
          this.setState(
            {
              isLogged: res.succes,
              redirect: res.succes ? false : true
            });
        }
      )
    this.getData()
  }

  logOut = () => {
    this.setState({ redirectLogOut: true })
    localStorage.setItem('token', "")
  }

  onClickHandler = () => {
    const data = new FormData();
    data.append("file", this.state.selectFileImages);
    fetch(SERVER_ADDRESS + '/uploadFile', {
      method: 'POST',
      mode: "cors",
      credentials: "same-origin",
      redirect: "follow",
      referrer: "no-referrer",
      body: data
    }).then(res => {
      console.log(res.statusText);
    });
  };

  onChangeHandler = event => {
    this.setState({
      selectFileImages: event.target.files[0],
      loaded1: true,
    }, () => this.setState({ liens: this.state.selectFileImages.name }));
  }

  render() {
    return (
      <>
        <Grid className="item" item>
          <Paper elevation={1}>
            <Card>
              <CardHeader
                className="jtestd"
                title="Accueil"
              />
              <Divider />
              <CardContent className="content">
                <PerfectScrollbar>
                  <div className="inner">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>#</TableCell>
                          <TableCell>Titre</TableCell>
                          <TableCell>Liens de l'image</TableCell>
                          <TableCell>Article</TableCell>
                          <TableCell>Editer</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.accueil.map((accueils, index) => (
                          <TableRow
                            hover
                            key={accueils.id}
                          >
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{accueils.titre}</TableCell>
                            <TableCell>{accueils.liens}</TableCell>
                            <TableCell>{accueils.text}</TableCell>
                            <TableCell>

                              <Button
                                style={{ backgroundColor: "#1976d2", color: 'white' }}
                                onClick={() => this.handleOpenPutModal(index)}
                                size="small"
                                startIcon={<Edit />}
                              >
                                Editer
                          </Button>

                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                </PerfectScrollbar>
              </CardContent>
            </Card>
          </Paper>
        </Grid>


        <Dialog
          open={this.state.deleteModalOpen}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Suppression de l'accueil"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Etes vous sur de vouloir supprimer l'accueil ?
              </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseDeleteModal} color="primary">
              Non
              </Button>
            <Button onClick={this.deleteBureau} color="primary" autoFocus>
              Oui
              </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.putModalOpen} onClose={this.handleClosePutModal} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Modifier l'accueil</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Pour modifer l'accueil veuillez saisir les champs obligatoires.
                </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="titre"
              label="Titre"
              type="text"
              fullWidth
              name="titre"
              onChange={this.handleChangeInput}
              defaultValue={this.state.titre}
            />
            <TextField
              margin="dense"
              id="text"
              label="Article"
              type="text"
              fullWidth
              name="text"
              multiline
              onChange={this.handleChangeInput}
              defaultValue={this.state.text}
            />
            <input
              style={{
                display: "none"
              }}
              accept="image/*"
              id="contained-button-file"
              multiple
              type="file"
              onChange={this.onChangeHandler}
            />
            <label htmlFor="contained-button-file">
              <Button
                variant="contained"
                color="primary"
                component="span"
                endIcon={<Image />}
              >
                Choisir une image
              </Button>
              {this.state.loaded1 ? this.state.selectFileImages.name : ""}
            </label>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClosePutModal} color="primary">
              Annuler
                  </Button>
            <Button onClick={this.putBureau} color="primary">
              Modifier
                  </Button>
          </DialogActions>
        </Dialog>


        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={this.state.snackbarOpen}
          message={this.state.snackbarMessage}
        />

      </>
    );
  }
}

export default Accueil;

